<template>
  <b-button
    class="animated fadeIn text-left text-white clearfix"
    :to="to"
    variant="primary"
    block
    @click="$emit('click')"
  >
    <i :class="`fal fa-${icon} mr-4 fa-2x float-left`" />
    <span class="float-left pt-1">{{ label }}</span>
  </b-button>
</template>

<script>
export default {
  name: "ActionButton",
  props: ["label", "icon", "to"],
};
</script>
